module.exports = __webpack_public_path__ + "f10330280c3e94885ebf362b8cdf3f51.MP3";